import React from 'react';
import { Spin, Button, Switch, Progress, Tooltip } from 'antd';
import { ReloadOutlined, PauseCircleOutlined } from '@ant-design/icons';
import { useApp } from '../../context/AppContext';

const RefreshIndicator = ({ onManualRefresh, paused = false }) => {
  const { isPollingEnabled, timeUntilRefresh, isRefreshing, togglePolling } =
    useApp();

  const effectivelyPaused = paused && isPollingEnabled;
  const progressPercent =
    isPollingEnabled && !paused ? ((15 - timeUntilRefresh) / 15) * 100 : 0;

  return (
    <div className="flex items-center gap-4 bg-gray-50 px-5 py-3 rounded-lg">
      <div className="flex items-center gap-3">
        <div className="relative flex items-center justify-center">
          {effectivelyPaused ? (
            <Tooltip title="Auto-refresh paused while searching">
              <PauseCircleOutlined style={{ fontSize: 24, color: '#9ca3af' }} />
            </Tooltip>
          ) : (
            <>
              <Progress
                type="circle"
                size={24}
                percent={progressPercent}
                showInfo={false}
                strokeColor="#10b981"
                strokeWidth={14}
                className="countdown-progress"
              />
              <span className="absolute inset-0 flex items-center justify-center text-xs font-bold text-gray-700 tracking-wider">
                {Math.ceil(timeUntilRefresh)}
              </span>
            </>
          )}
        </div>
      </div>

      <div className="flex items-center gap-3">
        <span className="text-sm text-gray-600 font-medium">
          {effectivelyPaused ? 'Paused:' : 'Auto-refresh:'}
        </span>
        <Switch
          size="small"
          checked={isPollingEnabled}
          onChange={togglePolling}
          loading={isRefreshing}
          disabled={effectivelyPaused}
        />
      </div>

      <Button
        type="text"
        size="small"
        icon={<ReloadOutlined spin={isRefreshing} />}
        onClick={onManualRefresh}
        loading={isRefreshing}
        disabled={isRefreshing}
        className="text-gray-600 hover:text-primary px-3"
      >
        Refresh
      </Button>

      {isRefreshing && (
        <div className="flex items-center gap-1">
          <Spin size="small" />
          <span className="text-xs text-gray-500">Updating...</span>
        </div>
      )}
    </div>
  );
};

export default RefreshIndicator;
